import { useNavigate } from 'react-router-dom';
import { logApi } from 'api';
import { GoogleIcon, MetaIcon, WhatsAppIcon } from 'components';
import { useCanCreateCampaign } from 'hooks/useCanCreateCampaign';
import { useAdsModal } from 'components/context/ModalsContext';

const { createLog } = logApi;
// Opciones de campañas disponibles
export const quickOptions = [
  {
    id: 1,
    text: "¡Hola! Quiero crear una campaña de Google Ads. ¿Me puedes ayudar?",
    message: "¡Hola! Quiero crear una campaña de Google Ads. ¿Me puedes ayudar?",
    icon: "google",
    title: "Google Ads",
    description: "Publicá anuncios en toda la red de Google.",
    hoverColor: "[#E53E3E]"
  },
  {
    id: 2,
    text: "¡Hola! Quiero crear una campaña de Meta Ads. ¿Me puedes ayudar?",
    message: "¡Hola! Quiero crear una campaña de Meta Ads. ¿Me puedes ayudar?",
    icon: "meta",
    title: "Meta Ads",
    description: "Publicá tus anuncios en Facebook e Instagram.",
    hoverColor: "[#0F31F7]"
  },
  {
    id: 3,
    text: "¡Hola! Quiero crear una campaña de WhatsApp. ¿Me puedes ayudar?",
    message: "¡Hola! Quiero crear una campaña de WhatsApp. ¿Me puedes ayudar?",
    icon: "whatsapp",
    title: "Whatsapp",
    description: "Crea anuncios para que la gente te escriba al Whatsapp",
    hoverColor: "[#25D366]"
  }
];

// Mapeo de colores para efectos hover
const hoverClassMap = {
  '[#E53E3E]': {
    border: 'hover:border-[#E53E3E]',
    text: 'group-hover:text-[#E53E3E]',
    icon: 'text-[#E53E3E]',
  },
  '[#0F31F7]': {
    border: 'hover:border-[#0F31F7]',
    text: 'group-hover:text-[#0F31F7]',
    icon: 'text-[#0F31F7]',
  },
  '[#25D366]': {
    border: 'hover:border-[#25D366]',
    text: 'group-hover:text-[#25D366]',
    icon: 'text-[#25D366]',
  }
};

const QuickOptions = ({ onSelect }) => {
  const navigate = useNavigate();
  const { canCreateCampaign } = useCanCreateCampaign();
  const { openUpdateBusinessDataModal } = useAdsModal();
  
  const options = quickOptions.map(option => ({
    ...option,
    action: () => option.action(onSelect)
  }));

  return (
    <div className="grid grid-cols-3 gap-2 sm:gap-3 w-full sm:w-auto sm:mx-auto">
      {options.map((option) => {
        const hoverClasses = hoverClassMap[option.hoverColor] || {};
        const buttonClassName = `p-2 sm:p-3 bg-white rounded-lg transition-all duration-200 text-left group border border-gray-200 ${hoverClasses.border}`;
        
        return (
          <button
            key={option.id}
            onClick={() => {
              createLog({
                level: 'info',
                message: `Click en QuickOptions (Chat): ${option.icon}`
              });
              if (canCreateCampaign) {
                navigate(`/campaign-wizard?platform=${option.icon}`);
              } else {
                openUpdateBusinessDataModal();
              }
            }}
            className={buttonClassName}
          >
            <div className="flex flex-col items-center gap-2 sm:gap-3">
              {/* Icono de la plataforma */}
              <div className={`h-6 w-6 sm:h-8 sm:w-8 rounded-lg flex items-center justify-center bg-opacity-0`}>
                {option.icon === 'google' && (
                  <GoogleIcon className={`h-3 w-3 sm:h-4 sm:w-4 ${hoverClasses.icon}`} />
                )}
                {option.icon === 'meta' && (
                  <MetaIcon className={`h-3 w-3 sm:h-4 sm:w-4 ${hoverClasses.icon}`} />
                )}
                {option.icon === 'whatsapp' && (
                  <WhatsAppIcon className={`h-5 w-5 sm:h-7 sm:w-7 ${hoverClasses.icon}`} />
                )}
              </div>
              {/* Título del botón */}
              <div className="text-center">
                <span className={`text-xs sm:text-sm font-medium text-gray-900 line-clamp-2 ${hoverClasses.text}`}>
                  {option.title}
                </span>
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default QuickOptions;